module.exports = __webpack_public_path__ + "img/6.6a4545bc.jpg";